/**
 * Generated by orval v6.11.0 🍺
 * Do not edit manually.
 * Snippets API
 * Test description
 * OpenAPI spec version: v1
 */
import { useQuery, useInfiniteQuery, useMutation } from '@tanstack/react-query'
import type { ErrorType } from '../../plugins/custom-instance'
import type { Category, ApiCategoriesListParams, MileageHistoriesOutput, MileagesInput } from './types'
import type {
  UseQueryOptions,
  UseInfiniteQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  UseInfiniteQueryResult,
  QueryKey,
} from '@tanstack/react-query'
import { customAxiosInstance } from '../../plugins/custom-instance'

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (config: any, args: infer P) => any ? P : never

export const apiCategoriesList = (
  params: ApiCategoriesListParams,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal
) => {
  return customAxiosInstance<Category[]>({ url: `/api/categories`, method: 'get', params, signal }, options)
}

export const getApiCategoriesListQueryKey = (params: ApiCategoriesListParams) => [
  `/api/categories`,
  ...(params ? [params] : []),
]

export type ApiCategoriesListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof apiCategoriesList>>>
export type ApiCategoriesListInfiniteQueryError = ErrorType<unknown>

export const useApiCategoriesListInfinite = <
  TData = Awaited<ReturnType<typeof apiCategoriesList>>,
  TError = ErrorType<unknown>
>(
  params: ApiCategoriesListParams,
  options?: {
    query?: UseInfiniteQueryOptions<Awaited<ReturnType<typeof apiCategoriesList>>, TError, TData>
    request?: SecondParameter<typeof customAxiosInstance>
  }
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getApiCategoriesListQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiCategoriesList>>> = ({ signal }) =>
    apiCategoriesList(params, requestOptions, signal)

  const query = useInfiniteQuery<Awaited<ReturnType<typeof apiCategoriesList>>, TError, TData>(
    queryKey,
    queryFn,
    queryOptions
  ) as UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryKey

  return query
}

export type ApiCategoriesListQueryResult = NonNullable<Awaited<ReturnType<typeof apiCategoriesList>>>
export type ApiCategoriesListQueryError = ErrorType<unknown>

export const useApiCategoriesList = <
  TData = Awaited<ReturnType<typeof apiCategoriesList>>,
  TError = ErrorType<unknown>
>(
  params: ApiCategoriesListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiCategoriesList>>, TError, TData>
    request?: SecondParameter<typeof customAxiosInstance>
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getApiCategoriesListQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiCategoriesList>>> = ({ signal }) =>
    apiCategoriesList(params, requestOptions, signal)

  const query = useQuery<Awaited<ReturnType<typeof apiCategoriesList>>, TError, TData>(
    queryKey,
    queryFn,
    queryOptions
  ) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryKey

  return query
}

export const healthMileagesCreate = (
  mileagesInput: MileagesInput,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<MileageHistoriesOutput>(
    { url: `/health/mileages`, method: 'post', headers: { 'Content-Type': 'application/json' }, data: mileagesInput },
    options
  )
}

export type HealthMileagesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof healthMileagesCreate>>>
export type HealthMileagesCreateMutationBody = MileagesInput
export type HealthMileagesCreateMutationError = ErrorType<unknown>

export const useHealthMileagesCreate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof healthMileagesCreate>>,
    TError,
    { data: MileagesInput },
    TContext
  >
  request?: SecondParameter<typeof customAxiosInstance>
}) => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {}

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof healthMileagesCreate>>, { data: MileagesInput }> = (
    props
  ) => {
    const { data } = props ?? {}

    return healthMileagesCreate(data, requestOptions)
  }

  return useMutation<Awaited<ReturnType<typeof healthMileagesCreate>>, TError, { data: MileagesInput }, TContext>(
    mutationFn,
    mutationOptions
  )
}

export const healthReviewsHasWritableList = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({ url: `/health/reviews/has-writable`, method: 'get', signal }, options)
}

export const getHealthReviewsHasWritableListQueryKey = () => [`/health/reviews/has-writable`]

export type HealthReviewsHasWritableListInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthReviewsHasWritableList>>
>
export type HealthReviewsHasWritableListInfiniteQueryError = ErrorType<unknown>

export const useHealthReviewsHasWritableListInfinite = <
  TData = Awaited<ReturnType<typeof healthReviewsHasWritableList>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseInfiniteQueryOptions<Awaited<ReturnType<typeof healthReviewsHasWritableList>>, TError, TData>
  request?: SecondParameter<typeof customAxiosInstance>
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getHealthReviewsHasWritableListQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthReviewsHasWritableList>>> = ({ signal }) =>
    healthReviewsHasWritableList(requestOptions, signal)

  const query = useInfiniteQuery<Awaited<ReturnType<typeof healthReviewsHasWritableList>>, TError, TData>(
    queryKey,
    queryFn,
    queryOptions
  ) as UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryKey

  return query
}

export type HealthReviewsHasWritableListQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthReviewsHasWritableList>>
>
export type HealthReviewsHasWritableListQueryError = ErrorType<unknown>

export const useHealthReviewsHasWritableList = <
  TData = Awaited<ReturnType<typeof healthReviewsHasWritableList>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof healthReviewsHasWritableList>>, TError, TData>
  request?: SecondParameter<typeof customAxiosInstance>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getHealthReviewsHasWritableListQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthReviewsHasWritableList>>> = ({ signal }) =>
    healthReviewsHasWritableList(requestOptions, signal)

  const query = useQuery<Awaited<ReturnType<typeof healthReviewsHasWritableList>>, TError, TData>(
    queryKey,
    queryFn,
    queryOptions
  ) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryKey

  return query
}
